var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`toggle ${_vm.value ? 'active' : ''}`,on:{"click":function($event){return _vm.$emit('input', !_vm.value)}}},[_c('div',{staticClass:"toggle-circle"})])
}
var staticRenderFns = []

export { render, staticRenderFns }